/**
 * Represents the state of anything requiring loading.
 */
export enum LoadingState {
  NotStarted = 'NOT STARTED',
  Loading = 'LOADING',
  Failure = 'FAILURE',
  Success = 'SUCCESS',
}
